import { Gobelet } from './Gobelet';
import { HeaderNavigationItemProps } from './components/HeaderNavigationItem';

export const headerNavigationData: HeaderNavigationItemProps[] = [
  {
    type: 'LINK',
    path: 'GAMES',
    title: 'header.games',
    hasCounter: false
  },
  {
    type: 'LINK',
    path: 'GAMES_LIVE',
    title: 'categoriesItem.live',
    hasCounter: false
  },
  {
    type: 'LINK',
    path: 'BONUSES',
    title: 'header.promo',
    hasCounter: true
  },
  {
    type: 'LINK',
    path: 'VIP',
    title: 'header.vip',
    hasCounter: false
  },
  {
    type: 'BUTTON',
    path: 'TOURNAMENTS',
    image: <Gobelet />,
    hasCounter: true
  }
];
